import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { useMemo } from 'react';
import {
  CollatorType,
  readCollatorFiltersConfigOptions,
} from '@agilelab/plugin-wb-search-common';

export const useSearchFilterConfig = (type: CollatorType) => {
  const configApi = useApi(configApiRef);

  return {
    filtersConfig: useMemo(
      () => readCollatorFiltersConfigOptions(configApi)[type],
      [configApi, type],
    ),
  };
};
